module.exports = __webpack_public_path__ + "static/img/shouxi.ea5f1e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shouxi.png
// module id = 675
// module chunks = 382